<template>
  <v-dialog v-model="dialog" max-width="500" persistent>
    <v-card>
      <v-card-title class="headline">
        <v-icon left color="primary">mdi-shield-account</v-icon>
        Verificar Identidad
      </v-card-title>
      
      <v-divider></v-divider>
      
      <v-card-text class="pt-4">
        <p class="mb-4 text-body-2 grey--text text--darken-1">
          Completa los siguientes datos para iniciar el proceso de verificación de identidad.
        </p>
        
        <v-form v-model="valid" ref="verifyForm" @submit.prevent="submitVerification">
          <v-text-field
            v-model="firstName"
            label="Nombres"
            required
            outlined
            :rules="nameRules"
            prepend-inner-icon="mdi-account"
          ></v-text-field>
          
          <v-text-field
            v-model="lastName"
            label="Apellidos"
            required
            outlined
            :rules="nameRules"
            prepend-inner-icon="mdi-account"
          ></v-text-field>
        </v-form>
      </v-card-text>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog" :disabled="loading">
          Cancelar
        </v-btn>
        <v-btn 
          color="#fff" 
          :loading="loading" 
          :disabled="!valid || !firstName || !lastName" 
          @click="submitVerification"
        >
          <v-icon left>mdi-check</v-icon>
          Continuar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";

export default {
  name: "VerifyIdentity",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      firstName: "",
      lastName: "",
      loading: false,
      valid: false,
      nameRules: [
        v => !!v || 'Este campo es requerido',
        v => (v && v.length >= 2) || 'Debe tener al menos 2 caracteres',
      ],
    };
  },
  watch: {
    show(val) {
      this.dialog = val;
    },
    dialog(val) {
      if (!val) {
        this.resetForm();
        this.$emit('close');
      }
    }
  },
  methods: {
    async submitVerification() {
      if (!this.valid || !this.firstName || !this.lastName) return;
      
      this.loading = true;
      try {
        const response = await axios.post('https://apitr.xyz/onlineapi/api/verifyIntegration/login', {
          firstName: this.firstName,
          lastName: this.lastName,
          url: window.location.origin

        });
        
        this.loading = false;
        
        if (response.data && response.data.status === 200 && response.data.retorno) {
          // Emite evento de éxito con la URL y verifyId
          this.$emit('verification-success', {
            url: response.data.retorno.urlResponse,
            verifyId: response.data.retorno.verifyId,
            message: "Iniciando verificación de identidad..."
          });
          this.closeDialog();
        } else {
          // Emite evento de error
          this.$emit('verification-error', {
            message: "No se pudo iniciar la verificación. Intenta más tarde."
          });
        }
      } catch (error) {
        this.loading = false;
        console.error('Error en verificación:', error);
        
        // Emite evento de error con mensaje específico
        this.$emit('verification-error', {
          message: error.response?.data?.message || "Error al conectar con el proveedor de verificación."
        });
      }
    },
    
    closeDialog() {
      this.dialog = false;
    },
    
    resetForm() {
      this.firstName = "";
      this.lastName = "";
      this.loading = false;
      this.valid = false;
      if (this.$refs.verifyForm) {
        this.$refs.verifyForm.resetValidation();
      }
    }
  }
};
</script>

<style scoped>
.v-card-title {
  background-color: #f8f9fa;
}
</style>